import Dynamic from "@/lib/dynamic";
import ComponentSpinner from "@/components/ui/componentSpinner";
import { parseTabId } from "@/contexts/tabsContext";
import { TabData } from "rc-dock";
import { TabPlaceholder } from "@/chat2/components/chatlayout/TabPlaceholder";
import { TabTitle } from "@/chat2/components/chatlayout/TabTitle";

export const ChatView = Dynamic(
  () =>
    import("./ChatView").then((mod) => ({ default: mod.ChatView })),
  { ssr: false, loading: () => <ComponentSpinner /> }
);

export const WorkspaceTabRenderer = (id: string): TabData => {
  const parsed = parseTabId(id);

  if (!parsed.entityId) {
    return {
      id,
      title: <TabTitle id={id} />,
      content: <TabPlaceholder title="Loading..." id={id} />
    }
  }

  return {
    id,
    title: <TabTitle id={id} />,
    content: <ChatView tabId={id} workspaceId={parsed.entityId} />
  }
}